/**
 * Created by calhosh on 7/13/2017.
 */
import React from 'react';
import styled from 'styled-components';
import MotifSearch from '@ey/motif-react-wrapper/Search';
import FormField from './MotifFormField';

export default function Search(props) {
	const {
		value,
		placeholder,
		onChange,
		onClear,
		styleName,
		darkBg,
		clearHoverText,
		searchHoverText,
		hideClearButton,
		onEnter,
		onSearchButtonClick,
		maxLength
	} = props;

	return (
		<Wrapper className={`${styleName} ${darkBg ? 'darkBgSearch' : ''}`}>
			<FormField>
				<MotifSearch
					aria-label="Search"
					name="navBarSearch"
					value={value}
					placeholder={placeholder}
					onChange={onChange}
					onClear={onClear}
					clearButtonTitle={clearHoverText}
					searchButtonTitle={searchHoverText}
					hideClearButton={hideClearButton}
					onEnter={onEnter}
					onSearchButtonClick={onSearchButtonClick}
					maxLength={maxLength ? maxLength : 100}
				/>
			</FormField>
		</Wrapper>
	);
}

const Wrapper = styled.section`
`;
